<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 24 24"
  fill="none"
>
  <circle cx="12"
          cy="12"
          r="11.5"
          [attr.fill]="bgColor"
          [attr.stroke]="circleColor"
  />
  <path d="M9.96917 16.4017L7 17L7.59917 14.0312L9.96917 16.4017ZM8.18833 13.4417L10.5583 15.8121L17 9.37042L14.6296 7L8.18833 13.4417Z"
        [attr.fill]="color"
  />
</svg>
